import axios from 'axios';

const API_BASE = window.location.protocol + '//' + window.location.host + '/api';

const request = axios.create({
  baseURL: API_BASE,
  timeout: 30000,
});

// 请求拦截器：自动带 token
request.interceptors.request.use(config => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// 响应拦截器：统一处理错误
request.interceptors.response.use(
  res => {
    if (res.data.code === 0) return res.data;
    return Promise.reject(res.data);
  },
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_user');
      window.location.href = '/ops/login';
    }
    return Promise.reject(err.response?.data || { message: '网络错误' });
  }
);

export default request;
